import React from 'react';
import Login from '../pages/Login';
import { useAppSelector } from '../store/hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, user, token } = useAppSelector((state) => state.auth);
  
  // If not authenticated OR missing user/token, show login page
  if (!isAuthenticated || !user || !token) {
    return <Login />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
